import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ListTemplate from "../components/template/list-template";
import { callApi } from "../components/common/Apis";

import $ from "jquery";
import _ from "underscore";

import modelObj from "../utils/cookieUtils";

import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

import { Dropdown } from "primereact/dropdown";

import { intervalLogging, stopLogging } from "../components/common/logger";
import { setItem } from "../utils/storageUtils";
import PulseLoader from "react-spinners/PulseLoader";

var retrievedGameList = null;
var localParams = null;
let skipGameList = "";

export default function GameList(props) {
    const [criteria, setCriteria] = useState(props.criteria);
    const [gameList, setGameList] = useState();
    const [sorting, setSorting] = useState("latest");
    const [listLoading, setListLoading] = useState(false);
    const [checked, setChecked] = useState(false);

    const location = useLocation();

    const sortBy = [
        { value: "latest", dataLang: "desc", label: "최신순" },
        { value: "match", dataLang: "asc", label: "차전순" },
    ];

    useEffect(() => {
        stopLogging();
        props.setMenuTitle("조회된 경기 목록");
        localParams = criteria;
        intervalLogging(location.pathname);

        let apiParam = { ...criteria };

        // 타자가 선택되어 있을 경우
        if(apiParam.batterIds.length != 0){
            if(apiParam.position == "batter"){
                apiParam.teamId = 0;
            } else {
                apiParam.oppTeamId = 0;
            }
        }
        // 투수가 선택되어 있을 경우
        if(apiParam.pitcherIds.length != 0){
            if(apiParam.position == "batter"){
                apiParam.oppTeamId = 0;
            } else {
                apiParam.teamId = 0;
            }
        }

        modelObj.renderLanguage();
        callApi("/hiball/tmp/game/multi/schedule", apiParam, successHandler);
        setListLoading(true);
    }, []);

    useEffect(() => {
        if (props.criteria) {
            setItem("gameCriteria", props.criteria);
        }
    }, [props.criteria]);

    useEffect(() => {
        if(gameList){
            checkSelectedGames(gameList);
        }
    },[props.criteria, gameList]);

    useEffect(() => {
        if(gameList){
            // 최초 로딩 시 선택된 값이 전체 목록 수와 동일한 경우
            if(props.criteria.gameInfoIds.length == gameList.length){
                // 목록 길이가 최소 1개 이상일 경우
                if(gameList.length > 0){
                    // 전체선택 체크박스 true
                    setChecked(true);
                }
            }
        }
    }, [gameList]);

    useEffect(() => {
        if (typeof gameList !== "undefined") {
            let newGames = sortingGamesHandler(gameList);
            setGameList(newGames);
        }
    }, [sorting]);

    let movingHandler = props.movingHandler;

    const sortingGamesHandler = (games) => {
        let newGames = [...games];
        var gameCnt;
        var videoTypes;
        var name;
        var className;

        var gameLen = newGames.length;

        if (gameLen > 0) {
            if (sorting === "latest") {
                gameCnt = gameLen + 1;
            } else if (sorting === "match") {
                gameCnt = 0;
            }
        }

        newGames.sort((a, b) => {
            videoTypes = a.videoType;

            if (typeof videoTypes === "string") {
                if (videoTypes != null && videoTypes !== "") {
                    a.videoType = videoTypes.split("/");
                } else {
                    a.videoType = null;
                }
            }

            if (sorting === "latest") {
                return new Date(b.gameDay) - new Date(a.gameDay);
            } else if (sorting === "match") {
                return new Date(a.gameDay) - new Date(b.gameDay);
            }
        });

        newGames.forEach(function (game) {
            videoTypes = game.videoType;
            if (videoTypes === null) {
                className = "inner-table disable-table";
            } else {
                name = "gameItems";
                className = "inner-table";
            }
            game.name = name;
            game.className = className;

            if (sorting === "latest") {
                gameCnt--;
            } else if (sorting === "match") {
                gameCnt++;
            }
            game.gameCnt = gameCnt;
        });

        return newGames;
    };

    const successHandler = (response) => {
        var result = response.data;
        var retrievedGames = result.resultList;

        retrievedGameList = retrievedGames;

        let sortedGames = sortingGamesHandler(retrievedGames);

        setGameList(sortedGames);
        setListLoading(false);

        pagination();

        var isCheckbase = localParams.checkbase == true;
        var isLatestGames = localParams.latestGames == true;
        var fromView = localParams.from;

        //만약 최근 6경기나 견제가 선택되어 있을 경우
        if (
            (typeof fromView === "undefined" || fromView !== "video") &&
            (isCheckbase || isLatestGames)
        ) {
            skipSelectingGames();
        }
    };

    //선택되어있는 경기 확인
    const checkSelectedGames = (sortedGames) => {
        let selectedItems = props.criteria.gameInfoIds;
        let relArr = [];

        //만약 선택된 경기가 있다면
        if (selectedItems.length > 0) {
            //배열을 돌면서 다시 생성 + 전체 목록에서 rel 값과 비교 => 동일하면 색칠
            selectedItems.forEach(function (item) {
                let rel = item.split("_"); //split 리턴값 자체가 배열임
                relArr.push(rel);
            });

            //중첩 반복문 이용
            //혹시나 위에 동작이 완료되기전에 실행되는 것은 아닌지 확인 필요
            sortedGames.forEach(function (item, idx) {
                relArr.forEach(function (contents) {
                    if (item.gameInfoId === contents[0]) {
                        //스타일 적용 및 클래스 추가
                        $("#leftRow_" + idx).addClass("select");
                        $("#rightRow_" + idx).addClass("select");
                        $("#videoType_" + contents[0]).val(contents[1]);
                    }
                });
            });

            if (props.useLang === "en") {
                $("#playingGame").html("Watch " + relArr.length + " Games");
            } else {
                $("#playingGame").html(relArr.length + " 경기 선택보기");
            }
        } else { // 선택된 경기가 없을 경우 스타일 제거 (전체선택 해제 시 필요)
            gameList.forEach(function (item, idx){
                $("#leftRow_" + idx).removeClass("select");
                $("#rightRow_" + idx).removeClass("select");
            });

            if (props.useLang === "en") {
                $("#playingGame").html("Watch 0 Games");
            } else {
                $("#playingGame").html("0 경기 선택보기");
            }
        }
    };

    const skipSelectingGames = () => {
        var isValid = true;
        var limit = 5;
        var size = _.size(retrievedGameList) - 1;

        if (size < limit) {
            limit = size;
        }

        var i = 0;
        var selectedGames = [];
        var selectedVideoTypes = [];

        while (isValid) {
            if (i <= limit) {
                var videoTypes = retrievedGameList[i].videoType;
                var gameInfoId = retrievedGameList[i].gameInfoId;
                var videoType = "";
                // 게임에 포함된 영상 유형 중 가장 앞에 있는 영상유형을 포함 시킴
                if (videoTypes != null) {
                    //영상 유형이 슬래시('/')로 구분되어 있는 경우와 배열로 되어있는 경우
                    if (videoTypes.indexOf("/") > 0)
                        videoType = videoTypes.substring(
                            0,
                            videoTypes.indexOf("/")
                        );
                    else videoType = videoTypes[0];
                    i++;
                }
                // selectedGames.push(gameInfoId + "_" + videoType);
                selectedGames.push(gameInfoId);
            } else {
                isValid = false;
            }
        }

        //현재 set이 완료되기 전에 playingGameHandler 함수를 실행하는것 같음
        if (selectedGames.length > 0) {
            skipGameList = selectedGames;
            playingGameHandler();
        }
    };

    const playingGameHandler = () => {
        let selectedGames = props.criteria.gameInfoIds;
        var isCheckbase = localParams.checkbase === true;
        var isLatestGames = localParams.latestGames === true;
        var fromView = localParams.from;

        //만약 최근 6경기나 견제가 선택되어 있을 경우
        if (
            (typeof fromView === "undefined" || fromView !== "video") &&
            (isCheckbase || isLatestGames)
        ) {
            props.setCriteria((prevState) => ({
                ...prevState,
                gameInfoIds: skipGameList,
            }));

            movingHandler("/clip/videoList");
        }
        //그렇지 않은데 선택된 값이 있는 경우
        else if (selectedGames.length > 0) {
            props.setCriteria((prevState) => ({
                ...prevState,
                gameInfoIds: selectedGames,
            }));
            movingHandler("/clip/videoList");
        }
        //체크박스 선택도 되어있지 않고 선택된 경기도 없을 때
        else {
            if (props.useLang === "en") {
                alert("Please choose the game first");
            } else {
                alert("경기를 먼저 선택해주십시오");
            }
        }
    };

    const changeSortingHandler = (evt) => {
        var sorting = evt.target.value;

        setSorting(sorting);
        //pagination();
    };

    const pagination = () => {
        $("[name='gameItems']").off("click");
        $("[name='retrieveVideo']").off("click");

        var useLang = modelObj.getLocalStorage("language");

        $("[name='selectedVideoTypes']").on("change", changeVideoTypeHandler);

        resizeDone();
    };

    const resizeDone = () => {
        //var height = window.innerHeight;

        //gameList 출력 영역 크기 조절
        //$("#gameListWrap").height(height-500);

        //모바일 또는 가로버전처럼 높이가 작을땐 리스트가 보이지 않아 고정적으로 정해둠
        $("#gameListWrap").height(500);
    };

    const changeVideoTypeHandler = () => {
        var targets = $("[name='gameItems']");

        var selectedItems = _.filter(targets, function (item) {
            return $(item).hasClass("select");
        });

        var gameArr = [];

        selectedItems.forEach(function (item) {
            var gameInfoId = $(item).attr("rel");
            gameArr.push(gameInfoId);
        });

        props.setCriteria((prevState) => ({
            ...prevState,
            gameInfoIds: gameArr,
        }));
    };

    //게임 목록 클릭 이벤트 핸들러
    const selectGameHandler = (evt) => {
        var target = $(evt.currentTarget);
        var targetName = target.attr("name");
        var targetRel = target.attr("rel");
        var targets = $("[name='" + targetName + "']");
        var taggingYn = "";

        var targetId = target.attr("id");
        var targetIdx = targetId.split("_");
        var num = targetIdx[1];

        gameList.forEach((item) => {
            if(item.gameInfoId == targetRel){
                if(item.initialPitchTime != (null || undefined || "")){
                    taggingYn = true;
                }
            }
        });

        // 태깅이 된 경우에만 클릭 이벤트 동작
        if(taggingYn){
            if (target.hasClass("select")) {
                //이미 선택되어있을때 (선택 취소)
                target.removeClass("select");
                $("#rightRow_" + num).removeClass("select");
            } else {
                //선택되어있지 않을때 (선택)
                target.addClass("select");
                $("#rightRow_" + num).addClass("select");
            }

            var selectedItems = targets.filter((item, value) =>
                $(value).hasClass("select")
            );

            var gameArr = [];

            selectedItems.each(function (item, value) {
                var gameInfoId = $(value).attr("rel");
                gameArr.push(gameInfoId);
            });

            props.setCriteria((prevState) => ({
                ...prevState,
                gameInfoIds: gameArr,
            }));

            if(gameArr.length == gameList.length){
                // 선택된 경기가 전체 경기 수와 같을 경우 (전체선택 true)
                setChecked(true);
            } else {
                // 그렇지 않을 경우 (전체선택 false)
                setChecked(false);
            }

            var useLang = modelObj.getLocalStorage("language");

            if (useLang === "en") {
                $("#playingGame").html("Watch " + gameArr.length + " Games");
            } else {
                $("#playingGame").html(gameArr.length + " 경기 선택보기");
            }
        }
    };

    const selectAllGamesCheckHandler = (evt) => {
        const checkData = evt.target.checked;
        setChecked(checkData);
        let selectedArr = props.criteria.gameInfoIds;

        if(checkData){
            // 전체선택 체크박스 true인 경우
            gameList.forEach((item) => {
                if(!selectedArr.includes(item.gameInfoId)){
                    // 태깅 되지 않은 경기 제외
                    if(item.initialPitchTime != (null || undefined || "")){
                        selectedArr.push(item.gameInfoId);
                    }
                }
            });
        } else {
            // 전체선택 체크박스 false인 경우
            selectedArr = [];
        }

        props.setCriteria((prevState) => ({
            ...prevState,
            gameInfoIds: selectedArr,
        }));
        
    }

    return (
        <div className="container-fluid">
            <div className="row list-top">
                <div className="col-12">
                    <div
                        className="input-group"
                        style={{ flexWrap: "nowrap", height: "40px" }}
                    >
                        <div className="input-group-prepend">
                            <span
                                className="input-group-text"
                                data-lang="sortBy"
                                style={{ width: "80px" }}
                            >
                                {"정렬"}
                            </span>
                        </div>
                        <Dropdown
                            id={"sorting"}
                            value={sorting}
                            options={sortBy}
                            onChange={changeSortingHandler}
                            name={"sorting"}
                            style={{ width: "100%", alignItems: "center" }}
                            optionLabel={
                                props.useLang == "en" ? "dataLang" : "label"
                            }
                        ></Dropdown>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 5, paddingRight: 5 }}>
                        <span style={{ color: "red", fontSize: 14 }}>
                            * 표시된 경우 태깅 되지 않은 경기입니다.
                        </span>
                        <span>
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={selectAllGamesCheckHandler}
                                style={{ marginRight: 5}}
                            />
                            <span data-lang="selectAll">전체선택</span>
                        </span>
                    </div>
                </div>
            </div>
            <div
                id="gameList"
                className="row game-list-wrap"
                style={{ padding: "10px" }}
            >
                <Table className="col-9" bordered>
                    <tbody>
                        <tr>
                            <td
                                className="game-list-title"
                                style={{ padding: "0px" }}
                            >
                                <div
                                    style={{
                                        overflowY: "scroll",
                                        height: "100%",
                                        width: "100%",
                                    }}
                                >
                                    <table
                                        style={{
                                            width: "100%",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        <tbody>
                                            <tr>
                                                <td
                                                    width="83%"
                                                    style={{ padding: "0px" }}
                                                >
                                                    <table
                                                        style={{
                                                            width: "100%",
                                                            fontSize: "15px",
                                                            textAlign: "center",
                                                            tableLayout:
                                                                "fixed",
                                                        }}
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    className="title title-main"
                                                                    width="10%"
                                                                    data-lang="gameSeq"
                                                                >
                                                                    차전
                                                                </th>
                                                                <th
                                                                    className="title title-main"
                                                                    width="15%"
                                                                    data-lang="gameDate"
                                                                >
                                                                    일자
                                                                </th>
                                                                <th
                                                                    className="title title-main"
                                                                    width="25%"
                                                                    data-lang="away"
                                                                >
                                                                    원정
                                                                </th>
                                                                <th
                                                                    className="title title-main"
                                                                    width="15%"
                                                                    data-lang="score"
                                                                >
                                                                    득점
                                                                </th>
                                                                <th
                                                                    className="title title-main"
                                                                    width="25%"
                                                                    data-lang="home"
                                                                    style={{
                                                                        borderRight:
                                                                            "none",
                                                                    }}
                                                                >
                                                                    홈
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td
                                id="gameListWrap"
                                className="game-list"
                                style={{ padding: "0px" }}
                            >
                                <div
                                    id="scrollList"
                                    style={{
                                        fontSize: "11px",
                                        overflowY: "scroll",
                                        height: "100%",
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        id="gameContents"
                                        style={{
                                            position: "relative",
                                            display: "flex",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <ListTemplate
                                                    list={gameList}
                                                    sorting={sorting}
                                                    listLoading={listLoading}
                                                    selectGameHandler={
                                                        selectGameHandler
                                                    }
                                                    useLang={props.useLang}
                                                />
                                            </tbody>
                                        </table>
                                        <div style={{position:"absolute", zIndex: "10"}}>
                                            {listLoading ? <PulseLoader color="#000000" height={15} width={5} radius={2} margin={2}/> : null}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
            <div className="row btn-wrap">
                <div
                    className="col-12"
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <Button
                        id="playingGame"
                        onClick={playingGameHandler}
                        className="btn shadow"
                        data-lang="watchClip"
                        variant="secondary"
                        style={{
                            width: "155px",
                            backgroundColor: "#000",
                            color: "#fff",
                        }}
                    >
                        선택보기
                    </Button>
                </div>
            </div>
            <input id="selectedGames" type="hidden" value="" />
            <input id="videoTypes" type="hidden" value="" />
        </div>
    );
}
